/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CertificateInfoDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100InternalServerException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100ServiceUnavailableException,
  ErrorResponseOfPtw100UnauthorizedException,
  TenantEmailSettingsDto,
  TenantEmailSettingsEditDto,
  TenantSecuritySettingsDto,
} from '../models/index';
import {
    CertificateInfoDtoFromJSON,
    CertificateInfoDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100InternalServerExceptionFromJSON,
    ErrorResponseOfPtw100InternalServerExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100ServiceUnavailableExceptionFromJSON,
    ErrorResponseOfPtw100ServiceUnavailableExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    TenantEmailSettingsDtoFromJSON,
    TenantEmailSettingsDtoToJSON,
    TenantEmailSettingsEditDtoFromJSON,
    TenantEmailSettingsEditDtoToJSON,
    TenantSecuritySettingsDtoFromJSON,
    TenantSecuritySettingsDtoToJSON,
} from '../models/index';

export interface SetKestrelCertificateSettingsRequest {
    file?: Blob;
    password?: string;
}

export interface SetTenantEmailSettingsRequest {
    tenantEmailSettingsEditDto?: TenantEmailSettingsEditDto;
}

/**
 * 
 */
export class TenantsApi extends runtime.BaseAPI {

    /**
     * Returns information about the server\'s current HTTPS certificate.
     */
    async getKestrelCertificateSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/tenants/certificate-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => CertificateInfoDtoFromJSON(jsonValue), "CertificateInfoDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => CertificateInfoDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns information about the server\'s current HTTPS certificate.
     */
     async getKestrelCertificateSettings(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TenantsApi['getKestrelCertificateSettingsRaw']>>, CertificateInfoDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = CertificateInfoDto;

         const response = this.getKestrelCertificateSettingsRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the email settings of the current tenant.
     */
    async getTenantEmailSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/tenants/email-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TenantEmailSettingsDtoFromJSON(jsonValue), "TenantEmailSettingsDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TenantEmailSettingsDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the email settings of the current tenant.
     */
     async getTenantEmailSettings(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TenantsApi['getTenantEmailSettingsRaw']>>, TenantEmailSettingsDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TenantEmailSettingsDto;

         const response = this.getTenantEmailSettingsRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the security settings of the current tenant.
     */
    async getTenantSecuritySettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/tenants/security-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TenantSecuritySettingsDtoFromJSON(jsonValue), "TenantSecuritySettingsDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TenantSecuritySettingsDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the security settings of the current tenant.
     */
     async getTenantSecuritySettings(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TenantsApi['getTenantSecuritySettingsRaw']>>, TenantSecuritySettingsDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TenantSecuritySettingsDto;

         const response = this.getTenantSecuritySettingsRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Replaces the server\'s HTTPS certificate with the uploaded one.
     */
    async setKestrelCertificateSettingsRaw(requestParameters: SetKestrelCertificateSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }

        if (requestParameters['password'] != null) {
            formParams.append('Password', requestParameters['password'] as any);
        }

        const response = await this.request({
            path: `/api/tenants/certificate-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => CertificateInfoDtoFromJSON(jsonValue), "CertificateInfoDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
          case 503: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ServiceUnavailableExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ServiceUnavailableException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => CertificateInfoDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Replaces the server\'s HTTPS certificate with the uploaded one.
     */
     async setKestrelCertificateSettings(requestParameters: SetKestrelCertificateSettingsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TenantsApi['setKestrelCertificateSettingsRaw']>>, CertificateInfoDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = CertificateInfoDto;

         const response = this.setKestrelCertificateSettingsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Updates the email settings of the current tenant.
     */
    async setTenantEmailSettingsRaw(requestParameters: SetTenantEmailSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/tenants/email-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantEmailSettingsEditDtoToJSON(requestParameters['tenantEmailSettingsEditDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TenantEmailSettingsEditDtoFromJSON(jsonValue), "TenantEmailSettingsEditDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TenantEmailSettingsEditDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Updates the email settings of the current tenant.
     */
     async setTenantEmailSettings(requestParameters: SetTenantEmailSettingsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TenantsApi['setTenantEmailSettingsRaw']>>, TenantEmailSettingsEditDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TenantEmailSettingsEditDto;

         const response = this.setTenantEmailSettingsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
